<div class="card mb-3" *ngIf="getFieldContent()">
  <div class="card-header">
    <strong>{{header}}</strong>
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item" [innerHTML]="getFieldContent()"></li>
  </ul>
</div>
